import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageHeader } from 'antd';

import { UsersList } from '@containers/users';
import UsersActions from '@redux/UsersRedux';
import './Users.less';

function UsersPage(props) {
  const { fetchUsers } = props;
  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="users main-page">
      <PageHeader
        title="Users"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
      />
      <UsersList />
    </div>
  );
}

UsersPage.propTypes = {
  fetchUsers: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  fetchUsers: () => dispatch(UsersActions.fetchUsers())
});

export default connect(
  null,
  mapDispatchToProps
)(UsersPage);
